<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Monatsabschluss</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createworkbalance')">Monatsabschluss anlegen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="workBalances != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="workBalances" :fields="fields">
                        <template slot="employee" slot-scope="row">
                            <p v-if="!$helpers.isBlank(employeeMap[row.item.employeeId])">
                                {{employeeMap[row.item.employeeId].firstName}} {{employeeMap[row.item.employeeId].lastName}}
                            </p>
                            
                        </template>
                        <template slot="dateLabel" slot-scope="row">
                            {{getMoment(row.item.date).format("MMMM YYYY")}}
                        </template>
                        
                        <template slot="actions" slot-scope="row">
                            
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
      
    </b-container>

    <b-modal ref="modal-createworkbalance"  no-close-on-backdrop no-close-on-esc centered title="Monatsabschluss anlegen" @cancel="hideModal('modal-createworkbalance')" @ok="createEmployeeWorkBalance" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                

                <b-form-group label-cols="4" label-cols-lg="4" label="Mitarbeiter" label-for="spotbu">
                    <b-form-select id = "employee" v-model="employeeWorkBalance.employeeId">
                         <option v-for="option in employeeMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.firstName }} {{ option.lastName }}
                        </option>
                    </b-form-select>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="4" label="Überstunden Konto" label-for="balance1">
                    <b-form-input id="balance1" v-model.number="employeeWorkBalance.workTimeBalance" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="4" label="Urlaub Konto" label-for="balance2">
                    <b-form-input id="balance2" v-model.number="employeeWorkBalance.vacationTimeBalance" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="4" label="Feiertag Konto" label-for="balance3">
                    <b-form-input id="balance3" v-model.number="employeeWorkBalance.holidayTimeBalance" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="4" label="Monat" label-for="month">
                    <b-form-input min="1" max="12" id="month" v-model.number="employeeWorkBalance.month" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="4" label="Jahr" label-for="year">
                    <b-form-input id="year" v-model.number="employeeWorkBalance.year" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Anmerkung" label-for="comment">
                    <b-form-input id="comment" v-model="employeeWorkBalance.comment"></b-form-input>
                </b-form-group>

               
            </div>
            
            <b-row v-if="balanceerror">
                Fehler beim Erstellen des Monatsabschlusses.
            </b-row>
        </b-container>
    </b-modal>
    
    <b-modal ref="modal-deleteworkbalance"  no-close-on-backdrop no-close-on-esc centered title="Monatsabschluss löschen" @cancel="hideModal('modal-deleteworkbalance')" @ok="deleteEmployeeWorkBalance" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie den Monatsabschluss löschen wollen?</p>
            </b-row>
            <b-row v-if="balanceerror" class="my-1">
                Fehler beim Löschen des Position.
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>
const moment = require('moment');
export default {
  name: 'employeeworkbalanceoverview',
  data () {
    return {
      employeeMap: {},
      workBalanceMap: {},
      workBalances: [],
      fields: [{key:"employee", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"dateLabel", label:"Datum", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                {key:"workTimeBalance", label:"Überstunden Konto", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                {key:"vacationTimeBalance", label:"Urlaub Konto", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                {key:"holidayTimeBalance", label:"Feiertag Konto", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},
                {key:"actions", label:"", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      employeeWorkBalance : {
          employeeId: null,
          year: new Date().getFullYear(),
          month: new Date().getMonth()+1,
          workTimeBalance: 0,
          vacationTimeBalance: 0,
          holidayTimeBalance: 0,
          comment: null
      },
      currentrow: {},
      balanceerror: false,
      
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function() {
        let view = this;
        this.loadEmployees()
        .then(response=>{
            view.updateEmployees(response.data)
            return view.loadEmployeeWorkBalances();
        })
        .then(response => {
            view.updateEmployeeWorkBalances(response.data);
            
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    createEmployeeWorkBalance: function(evt){
        evt.preventDefault();
        this.balanceerror=false;
        let view = this;
        let url = '/api/sec/employeeworkbalance';
        let params = {
            storeId: this.$store.state.storeId
        };
        let payload = {
          employeeId: this.employeeWorkBalance.employeeId,
          year: this.employeeWorkBalance.year,
          month: this.employeeWorkBalance.month,
          workTimeBalance: this.employeeWorkBalance.workTimeBalance,
          vacationTimeBalance: this.employeeWorkBalance.vacationTimeBalance,
          holidayTimeBalance: this.employeeWorkBalance.holidayTimeBalance,
          comment: this.employeeWorkBalance.comment
        };

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.workBalances.push(response.data.data);
            
            view.hideModal('modal-createworkbalance');
        }).catch(function (error) {
            view.balanceerror=true;
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentrow = row;
        this.showModal('modal-deleteworkbalance');
    },
    deleteEmployeeWorkBalance: function(evt){
        evt.preventDefault();
        this.spoterror=false;
        let view = this;
        let url = '/api/sec/employeeworkbalance';
        
        let params = {
            id: this.currentrow.item.id,
            storeId: this.$store.state.storeId
        };
        
        
        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = view.workbalances.findIndex(balance => balance.id === view.currentrow.item.id) 
            if (~index) {
                view.workbalances.splice(index, 1);
            }     
            view.hideModal('modal-deleteworkbalance');
        }).catch(function (error) {
            view.spoterror=true;
            console.log(error)
        })

    },
    loadEmployeeWorkBalances : function() {
        let view = this;
        let url = '/api/sec/employeeworkbalance';
        
        let params = {
            storeId: this.$store.state.storeId
        };
      
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
			
    },
    getMoment: function(str){
        return moment(str);
    },
    loadEmployees : function() {
        let view = this;
        let url = '/api/sec/employee';
        
        let params = {
            storeId: this.$store.state.storeId
        };
      
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
			
    },
    updateEmployees: function(data){
        
        let employeeMap = {}

        for (let i = 0; i < data.length; i++) { 
            employeeMap[data[i].id] = data[i];
        }

        this.employeeMap = employeeMap;
    },
    updateEmployeeWorkBalances: function(data) {
        let workBalanceMap = {};
        let workBalances = [];
        for (let i = 0; i < data.length; i++) { 
            workBalanceMap[data[i].id] = data[i];
            workBalances.push(data[i])
        }

        this.workBalanceMap = workBalanceMap;
        this.workBalances = workBalances;
    },
    
    hideModal (ref) {
        this.balaanceerror=false;
        this.employeeWorkBalance = {
          employeeId: null,
          year: new Date().getFullYear(),
          month: new Date().getMonth()+1,
          workTimeBalance: 0,
          vacationTimeBalance: 0,
          holidayTimeBalance: 0,
          comment: null
        };

        this.currentrow={};
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
        
  },
  watch: { 
  }

}
</script>

<style scoped>

</style>
